import { all, call, put, takeLatest } from 'redux-saga/effects';
import request from 'utils/request';
import urls from 'utils/config';
import { fetchWorkflowsFailure, fetchWorkflowsSuccess } from './actions';
import workflowsTypes from './types';
import { networkErrorHandler } from 'utils/errrorHandlers';


const { API_BASE_URL } = urls || {};

function* fetchWorkflows() {
  const url = `${API_BASE_URL}/workflow`;

  const response = yield request({
    method: 'get',
    url,
  });
  if (response.success) {
    yield put(fetchWorkflowsSuccess(response.raw));
  } else {
    yield put(
      fetchWorkflowsFailure(
        'An error occured. Please reload the page to try again.'
      )
    );
    networkErrorHandler(response?.statusCode, response?.message);
  }
}

function* onUpdateAdminLevels() {
  yield takeLatest(workflowsTypes.FETCH_WORKFLOWS_REQUEST, fetchWorkflows);
}

export default function* workflowsSagas() {
  yield all([call(onUpdateAdminLevels)]);
}
